export async function resolveConsent(
  serviceIdOrName: string
): Promise<null | boolean> {
  if (typeof window === "undefined" || !window.UC_UI) return null;

  try {
    const services = await window.UC_UI.getServicesBaseInfo();

    const service = services.find(
      (s) => s.id === serviceIdOrName || s.name === serviceIdOrName
    );

    return service ? service.consent.status : null;
  } catch (e) {
    console.error("[Analytics] Usercentrics error:", e);
    return null;
  }
}
